import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { useRef } from 'react';
import { FaRocket, FaMobileAlt, FaGem, FaTrophy, FaSnowflake } from 'react-icons/fa';

const CallToAction = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-100px" });
  const contractAddress = "9w3pJSRhxPFAvsxNJDkQJXFPnVCKWYeba";

  const copyToClipboard = () => {
    navigator.clipboard.writeText(contractAddress);
  };

  return (
    <section ref={ref} className="relative py-32 px-4">
      <div className="max-w-5xl mx-auto">
        <motion.div
          initial={{ opacity: 0, scale: 0.95 }}
          animate={isInView ? { opacity: 1, scale: 1 } : { opacity: 0, scale: 0.95 }}
          transition={{ duration: 0.8 }}
          className="relative overflow-hidden bg-gradient-to-br from-rizzmas-red via-rizzmas-dark to-rizzmas-green rounded-3xl p-1"
        >
          <div className="bg-rizzmas-dark rounded-3xl p-12 md:p-16">
            <motion.h2
              initial={{ opacity: 0, y: 20 }}
              animate={isInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 20 }}
              transition={{ duration: 0.6, delay: 0.2 }}
              className="text-4xl md:text-6xl font-black mb-6 text-center bg-gradient-to-r from-rizzmas-gold to-rizzmas-cream bg-clip-text text-transparent"
            >
              Join the Takeover
            </motion.h2>

            <motion.p
              initial={{ opacity: 0, y: 20 }}
              animate={isInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 20 }}
              transition={{ duration: 0.6, delay: 0.3 }}
              className="text-xl md:text-2xl text-rizzmas-cream/90 text-center mb-12 leading-relaxed"
            >
              The official Rizzmas Marketing Donation Wallet will be live on the website.
              <br />
              <span className="text-rizzmas-gold font-semibold">All funds are transparently tracked</span> and used only for viral marketing,
              creator pushes, and exchange listings.
            </motion.p>

            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={isInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 20 }}
              transition={{ duration: 0.6, delay: 0.4 }}
              className="bg-rizzmas-dark/60 backdrop-blur-sm border-2 border-rizzmas-gold/50 rounded-2xl p-8 mb-8"
            >
              <p className="text-sm text-rizzmas-gold/80 mb-3 uppercase tracking-wide font-bold text-center">
                Contract Address
              </p>
              <div className="flex items-center justify-center gap-3 flex-wrap">
                <code className="text-rizzmas-cream font-mono text-sm md:text-base bg-rizzmas-dark/80 px-4 py-3 rounded-lg border border-rizzmas-green/30 break-all">
                  {contractAddress}
                </code>
                <motion.button
                  whileHover={{ scale: 1.05 }}
                  whileTap={{ scale: 0.95 }}
                  onClick={copyToClipboard}
                  className="px-4 py-3 bg-rizzmas-green text-white font-bold rounded-lg hover:bg-rizzmas-green/80 transition-colors"
                >
                  Copy
                </motion.button>
              </div>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={isInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 20 }}
              transition={{ duration: 0.6, delay: 0.5 }}
              className="space-y-6"
            >
              <div className="grid md:grid-cols-3 gap-6">
                <motion.div
                  whileHover={{ scale: 1.05, y: -5 }}
                  className="bg-gradient-to-br from-rizzmas-red/20 to-rizzmas-red/5 border border-rizzmas-red/30 rounded-xl p-6 text-center"
                >
                  <div className="text-4xl mb-3 flex justify-center text-rizzmas-red">
                    <FaRocket />
                  </div>
                  <h3 className="text-lg font-bold text-rizzmas-cream mb-2">Viral Marketing</h3>
                  <p className="text-sm text-rizzmas-cream/70">Spread the Rizz globally</p>
                </motion.div>

                <motion.div
                  whileHover={{ scale: 1.05, y: -5 }}
                  className="bg-gradient-to-br from-rizzmas-green/20 to-rizzmas-green/5 border border-rizzmas-green/30 rounded-xl p-6 text-center"
                >
                  <div className="text-4xl mb-3 flex justify-center text-rizzmas-green">
                    <FaMobileAlt />
                  </div>
                  <h3 className="text-lg font-bold text-rizzmas-cream mb-2">Creator Pushes</h3>
                  <p className="text-sm text-rizzmas-cream/70">Amplify the movement</p>
                </motion.div>

                <motion.div
                  whileHover={{ scale: 1.05, y: -5 }}
                  className="bg-gradient-to-br from-rizzmas-gold/20 to-rizzmas-gold/5 border border-rizzmas-gold/30 rounded-xl p-6 text-center"
                >
                  <div className="text-4xl mb-3 flex justify-center text-rizzmas-gold">
                    <FaGem />
                  </div>
                  <h3 className="text-lg font-bold text-rizzmas-cream mb-2">Exchange Listings</h3>
                  <p className="text-sm text-rizzmas-cream/70">To the moon and beyond</p>
                </motion.div>
              </div>

              <motion.div
                initial={{ opacity: 0 }}
                animate={isInView ? { opacity: 1 } : { opacity: 0 }}
                transition={{ duration: 0.8, delay: 0.7 }}
                className="bg-gradient-to-r from-rizzmas-green/20 to-rizzmas-red/20 border border-rizzmas-gold/40 rounded-xl p-6 text-center"
              >
                <p className="text-lg text-rizzmas-gold font-bold mb-2 flex items-center justify-center gap-2">
                  <FaTrophy className="text-xl" />
                  Live Leaderboard Coming Soon
                </p>
                <p className="text-rizzmas-cream/80">
                  Anyone can join the ranks and fund the Christmas comeback
                </p>
              </motion.div>

              <motion.div
                initial={{ opacity: 0, scale: 0.9 }}
                animate={isInView ? { opacity: 1, scale: 1 } : { opacity: 0, scale: 0.9 }}
                transition={{ duration: 0.6, delay: 0.8 }}
                className="flex justify-center pt-6"
              >
                <motion.button
                  whileHover={{
                    scale: 1.05,
                    boxShadow: "0 0 40px rgba(252, 211, 77, 0.6)"
                  }}
                  whileTap={{ scale: 0.95 }}
                  className="px-12 py-5 bg-gradient-to-r from-rizzmas-red to-rizzmas-green text-white text-xl font-black rounded-xl shadow-2xl shadow-rizzmas-gold/30 hover:shadow-rizzmas-gold/60 transition-all duration-300 flex items-center gap-3"
                >
                  Donate Now
                  <FaSnowflake className="text-2xl" />
                </motion.button>
              </motion.div>
            </motion.div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default CallToAction;
